import React, { Component } from 'react';
import User from './User'
import { Card, CardBody, Button, ButtonGroup } from 'reactstrap';
import './css/Route.css';
import moment from 'moment';
import { AllowReservationToday } from '../config/config'

class Route extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedStopId: null,
            selectedTmSequence: null,
            routeinfo: [],
            timetables: [],
	    departingTimetables: [],
            message: "乗りたいバス停を選んでください",
            memo: "なし",
            loading: true,
            timetableLoading: false,
	    departingTimetableLoading: false
        };
    }

    isHoliday = (baseDate) => {
        const { holidays } = this.props;
        const holidayDates = new Set(holidays.map(h => moment(h, 'YYYY-MM-DD').format('YYYY-MM-DD')));
        return holidayDates.has(baseDate.format('YYYY-MM-DD'));
    }

    subtractADaySkippingHolidays = (baseDate) => {
        let prevDay = baseDate.clone().subtract(1, 'days');
        while (this.isHoliday(prevDay)) {
            prevDay = prevDay.clone().subtract(1, 'days');
        }
        return prevDay;
    }

    componentDidMount() {
        this.populateRouteData();
        this.populateTimetableData();
	this.populateDepartingTimetableData();
    }

    componentDidUpdate(prevprops) {
        if (prevprops.rsvdate !== this.props.rsvdate) {
            this.setState({ selectedStopId: null, selectedTmSequence: null, message: "乗りたいバス停を選んでください" });
            this.populateRouteData();
            this.populateTimetableData();
	    this.populateDepartingTimetableData();
        }
    }

    render() {
        const { routeId, rsvdate } = this.props;
        const { loading, routeinfo, timetables, departingTimetables, selectedStopId, selectedTmSequence, message, timetableLoading, departingTimetableLoading, memo } = this.state;

        return (
            <Card className="block">
                <CardBody>
                    {loading && <div>読み込み中...</div>}
                    {!loading && (
                        <>
                            <div className="message">{Route.getDateFormat(this.props.rsvdate)}のバス予約： {message}</div>
                            <div className="button-groups-container">
                                <div className="button-group-container">
                                    <ButtonGroup vertical>
                                        {this.state.routeinfo.map(stop => (
                                            <Button
                                                key={stop.sequence}
                                                color={this.state.selectedStopId === stop.stopId ? 'primary' : 'secondary'}
                                                onClick={() => this.handleStopSelect(stop.stopId, stop.sequence)}>
                                                {stop.stopName} {stop.memo}
                                            </Button>
                                        ))}
                                    </ButtonGroup>
                                </div>
                                {selectedStopId && (
                                    <>
                                        <div className="button-group-container">
                                            <ButtonGroup vertical>
                                                {Array.isArray(this.state.timetables) && this.state.timetables.map(stop => {
							const now = moment();
							const today = moment().format("YYYY-MM-DD");
							const lastBusinessDay = moment(this.subtractADaySkippingHolidays(moment(rsvdate)));
							const tenThirty = moment(rsvdate).startOf('day').add(10, 'hours').add(20, 'minutes');
							const seventeenHundred = moment().startOf('day').add(17, 'hours');
							const eighteenThirty = moment().startOf('day').add(18, 'hours').add(30, 'minutes');
							const isToday = moment(rsvdate).format("YYYY-MM-DD") === today;
							const isLastBusinessDay = lastBusinessDay.format("YYYY-MM-DD") === today;
							const isLastBusinessDaySaturday = lastBusinessDay.day() === 6; // 6 = Saturday
							const isAfterLastBusinessDay = !isLastBusinessDay && lastBusinessDay.isBefore(moment());
							const match = this.state.departingTimetables.find(dt => dt.sequence === stop.sequence);

							console.log("R ReservationDate: ", moment(rsvdate).format("YYYY-MM-DD"));
							console.log("R LastBusinessDate: ", lastBusinessDay.format("YYYY-MM-DD"));
							console.log("R Today", today);
							console.log(isLastBusinessDay);

							// 前営業日の１８：３０以降であれば１０：２０以前の予約はグレーアウト。前営業日が土曜日の場合、１７：００がタイムリミット

							const dsDepartureDateTime = moment(`${moment(rsvdate).format("YYYY-MM-DD")} ${match.departureTime}`, "YYYY-MM-DD HH:mm:ss");
							const departureDateTime = moment(`${moment(rsvdate).format("YYYY-MM-DD")} ${stop.departureTime}`, "YYYY-MM-DD HH:mm:ss");
							console.log("Now:", now.format("MM/DD HH:mm:ss"));
							console.log("DSDeparture:", dsDepartureDateTime.format("MM/DD HH:mm:ss"));
							console.log("StopDeparture:", departureDateTime.format("MM/DD HH:mm:ss"));
						const isTooLate = (isToday && (dsDepartureDateTime.isBefore(tenThirty) || now.isAfter(dsDepartureDateTime.clone().subtract(2, 'hours')))) ||
									(isLastBusinessDay && isLastBusinessDaySaturday && (now.clone().isAfter(seventeenHundred) && dsDepartureDateTime.clone().isBefore(tenThirty))) ||
									(isLastBusinessDay && (now.clone().isAfter(eighteenThirty) && dsDepartureDateTime.clone().isBefore(tenThirty))) ||
									(isAfterLastBusinessDay && dsDepartureDateTime.clone().isBefore(tenThirty));
							return (
                                                    <Button
                                                        key={stop.sequence}
                                                        color={this.state.selectedTmSequence === stop.sequence ? 'primary' : 'secondary'}
                                                        onClick={() => this.handleTimeSelect(stop.sequence)}
							disabled={isTooLate}>
                                                        {stop.sequence}便: {moment(stop.departureTime, "HH:mm:ss").format("HH:mm")} {stop.memo}
                                                    </Button>
							)}
						)}
                                            </ButtonGroup>
                                        </div>
                                    </>
                                )}
                                {selectedTmSequence && (
                                    <div className="button-group-container">
                                        <textarea
                                            value={memo} 
                                            onChange={this.handleMemoChange}  
                                        />
                                        <Button
                                            color='primary'
                                            onClick={() => this.handleReserve(selectedStopId, selectedTmSequence, this.props.isToSchool, this.state.memo)}>
                                            予約
                                        </Button>
                                    </div>
                                )}
                            </div>
                        </>
                    )}
                </CardBody>
            </Card>
        );
    }

    static getDateFormat(date) {
        const year = date.getFullYear();  // 2023
        const month = date.getMonth() + 1; // 10 (月は0から始まるので+1を行う)
        const day = date.getDate();      // 19
        return year + "年" + month + "月" + day + "日";
    }

    async populateRouteData() {
        try {
            var userNumber = User.getNumber();
            const response = await fetch(`busreservation/getroutestops?routeId=${this.props.routeId}&userId=${userNumber}`);
            const routedata = await response.json();
            this.setState({ routeinfo: routedata, loading: false });
        } catch (error) {
            console.error('Failed to fetch bus data', error);
            this.setState({ loading: false });
        }
    }

    async populateDepartingTimetableData() {
        try {
            const rsvdate = this.props.rsvdate instanceof Date ? this.props.rsvdate.toISOString() : this.props.rsvdate;
            const tmresponse = await fetch(`busreservation/getroutetimetables?routeId=${this.props.routeId}&stopId=${this.props.firstStopId}&date=${rsvdate}`);
            const departingTimetabledata = await tmresponse.json();
	
            this.setState({ departingTimetables: departingTimetabledata, departingTimetableLoading: false });
	} catch (error) {
            console.error('failed to fetch bus departing timetable data', error);
            this.setState({ departingTimetableLoading: false });
	}
    }

    async populateTimetableData() {
        if (this.state.selectedStopId === null) {
            this.setState({ timetables: [], timetableLoading: false });
            return;
        }
        this.setState({ timetableLoading: true });
        try {
            const rsvdate = this.props.rsvdate instanceof Date ? this.props.rsvdate.toISOString() : this.props.rsvdate;
            const tmresponse = await fetch(`busreservation/getroutetimetables?routeId=${this.props.routeId}&stopId=${this.state.selectedStopId}&date=${rsvdate}`);
            const timetabledata = await tmresponse.json();
            this.setState({ timetables: timetabledata, timetableLoading: false });
        } catch (error) {
            console.error('Failed to fetch bus timetable data', error);
            this.setState({ timetableLoading: false });
        }
    }

    async sendBusReservation(stopId, sequence, isEnroute, memo) {
        try {
            if (memo == '') {
                memo = 'なし';
            }
            const rsvdate = this.props.rsvdate instanceof Date ? this.props.rsvdate.toISOString() : this.props.rsvdate;
            var userNumber = User.getNumber();
            let formData = new FormData();
            formData.append("personNum", userNumber);
            formData.append("stopId", stopId);
            formData.append("rsvdate", rsvdate);
            formData.append("sequence", sequence);
            formData.append("isenroute", isEnroute);
            formData.append("memo", memo);

            await fetch("busreservation/reservebusride", {
                method: "POST",
                body: formData
            }).then(async response => await response.json())
                .then(data => {
                    console.log(data);
                    this.setState({ message: '予約が完了しました' });
                    // do a page refresh
                    this.props.childToParent();
                });
        } catch (error) {
            console.error('Failed to fetch bus data', error);
            this.setState({ loading: false, message: '予約に失敗しました' });
        }
    }

    handleStopSelect = (stopId, sequence) => {
        if (sequence == 1) {
            this.setState({ selectedStopId: stopId, selectedTmSequence: null, timetables: [], message: "始発の予約はできません" });
            return;
        }
        this.setState({ selectedStopId: stopId, selectedTmSequence: null, message: "乗りたいバスの便を選んでください" }, () => {
            this.populateTimetableData();
        });
    }

    handleTimeSelect = (sequence) => {
        this.setState({ selectedTmSequence: sequence, message: "その他ご要望はありますか？" }, () => {
            this.populateTimetableData();
        });
    }

    handleMemoChange = (event) => {
        this.setState({ memo: event.target.value });
    }

    handleReserve = (stopId, sequence, isEnroute, memo) => {
        this.sendBusReservation(stopId, sequence, isEnroute, memo);
    }
}

export default Route;

